import Navbar from "./Navbar_View";
import Footer from "./Contact_Footer_View";
import { useEffect } from "react";

export function Homescreen() 
{
    return (
        <>
            <Navbar />

            <div className="grid grid-cols-2 md:grid-cols-4 p-[2%]">
                <div className="shop-item">
                    <img src={require("./images/IMG-20240229-WA0003.jpg")} />
                    <h3>name</h3>
                    <p>description</p>
                </div>
                <div className="shop-item">
                    <img src={require("./images/IMG-20240224-WA0003smaller.jpg")} />
                    <h3>name</h3>
                    <p>description</p>
                </div>  
                <div className="shop-item">
                    <img src={require("./images/IMG-20240901-WA0004.jpg")} />
                    <h3>name</h3>
                    <p>description</p>
                </div>  
                <div className="shop-item">
                    <img src={require("./images/IMG-20240901-WA0012.jpg")} />
                    <h3>name</h3>
                    <p>description</p>
                </div>       
            </div>
            
            <Footer />
        </>
    );
}

export default Homescreen;